module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"errores":"errores","error":"<span class=\u0027font-weight-bold\u0027>{0}</span>: {1}","indicador":"Indicador","titulo_modal":"Descripción de los errores","cerrar":"Cerrar"}}')
  delete Component.options._Ctor
}
